import type { JsonObject, JsonValue } from "src/components/views/ai/assistant/uiContext/jsonTypes.ts";

export function toJsonValue(value: unknown): JsonValue | undefined {
	if (value === undefined || typeof value === "function" || typeof value === "symbol") {
		return undefined;
	}
	if (value === null || typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
		return value;
	}
	if (value instanceof Date) {
		return value.toISOString();
	}
	if (Array.isArray(value)) {
		return value.map(toJsonValue).filter((item): item is JsonValue => item !== undefined);
	}
	if (typeof value === "object") {
		const objectValue: JsonObject = {};
		for (const [key, entryValue] of Object.entries(value)) {
			const jsonValue = toJsonValue(entryValue);
			if (jsonValue !== undefined) {
				objectValue[key] = jsonValue;
			}
		}
		return objectValue;
	}
	return undefined;
}

export function toJsonObject(value: unknown): JsonObject {
	const jsonValue = toJsonValue(value);
	return isJsonObject(jsonValue) ? jsonValue : {};
}

function isJsonObject(value: JsonValue | undefined): value is JsonObject {
	return value != null && typeof value === "object" && !Array.isArray(value);
}
